import React, { useEffect, useState } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import BaseUrl from "../../../../constants/BaseUrl";
import { useSelector } from "react-redux";
import TransactionsList from "../../home/transactionsList";
import MyLoader from "../../../reusebale/myLoader";
import db from "../../../../db/index.json";

const PropertyTransactionsSection = ({ propertyId }) => {
  const { rightPanel } = db;
  const { loginSuccess } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [leaseMap, setLeaseMap] = useState({}); // Map leaseId to lease details for tenant info

  const fetchTransactions = async () => {
    if (!propertyId) return;

    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      // Fetch all transactions for this property
      const transactionsResponse = await fetch(
        `${BaseUrl}api/payment-transaction/property/${propertyId}`,
        requestOptions
      );
      const transactionsResult = await transactionsResponse.json();

      if (transactionsResult.status === "success" && transactionsResult.data) {
        // Sort by createdAt descending (newest first)
        const sortedTransactions = transactionsResult.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setTransactions(sortedTransactions);

        // Get unique lease IDs from transactions
        const uniqueLeaseIds = [...new Set(sortedTransactions.map(t => t.leaseId).filter(Boolean))];

        // Fetch lease details for tenant info
        if (uniqueLeaseIds.length > 0) {
          const leaseDetailsPromises = uniqueLeaseIds.map(leaseId => 
            fetch(`${BaseUrl}api/lease/getLeaseDetails/${leaseId}`, requestOptions)
              .then(res => res.json())
              .then(result => result.success ? { leaseId, data: result.data } : null)
              .catch(() => null)
          );

          const leaseDetailsResults = await Promise.all(leaseDetailsPromises);
          const leaseMapResult = {};
          leaseDetailsResults.forEach(result => {
            if (result) {
              leaseMapResult[result.leaseId] = result.data;
            }
          });
          setLeaseMap(leaseMapResult);
        }
      } else {
        setTransactions([]);
      }
    } catch (error) {
      console.error("Error fetching property transactions:", error);
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (propertyId && loginSuccess?.token) {
      fetchTransactions();
    }
  }, [propertyId, loginSuccess?.token]);

  // Get lease details for a transaction (for tenant info)
  const getLeaseDetailsForTransaction = (transaction) => {
    if (!transaction.leaseId) return null;
    return leaseMap[transaction.leaseId] || null;
  };

  return (
    <div className="bg-white rounded-2xl py-5 px-4 w-full mt-5 shadow-md shadow-gray-200 transition-all duration-300 hover:opacity-90">
      <div className="flex justify-between items-center">
        <ParagraphTag
          content="Transactions"
          classes="text-darkColor font-popinsSemiBold text-xl"
        />
      </div>
      
      <div className="mt-5">
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <MyLoader />
          </div>
        ) : (
          <TransactionsList
            transactions={transactions}
            loading={loading}
            leaseDetails={null}
            leaseDetailsMap={leaseMap}
            limit={null}
            showHeaders={true}
            showExtendedColumns={true}
          />
        )}
      </div>
    </div>
  );
};

export default PropertyTransactionsSection;
